import Form from 'components/Form';

import { Grid, Typography } from '@mui/material';

import RowContainer from '../components/RowContainer';
import RowContent from '../components/RowContent';

import { Ti18nId } from 'hooks/useI18n';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';

import SectionTitle from '../components/SectionTitle';
import { Stack } from '@mui/system';

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
  onRequired: (id: Ti18nId) => void;
  onSuccess: (message: string) => void;
}

const checks = [
  { label: '耐甲氧西林金\n黄色葡萄球菌', key: 'assessment_contact.checked1' }, // MRSA
  { label: '艰难梭菌', key: 'assessment_contact.checked2' }, // C-Diff
  { label: '超广谱β-内酰胺酶', key: 'assessment_contact.checked3' }, // ESBL
  { label: '流感', key: 'assessment_contact.checked4' },
  { label: '飞沫', key: 'assessment_contact.checked5' },
  { label: '中性粒细胞减少', key: 'assessment_contact.checked6' },
];

const checks2 = [
  { label: '尿培养', key: 'assessment_need.checked1' },
  { label: '呼吸道培养', key: 'assessment_need.checked2' },
  { label: '流感拭子', key: 'assessment_need.checked3' },
  { label: 'MRSA拭子', key: 'assessment_need.checked4' },
];

const checks3 = [
  { label: '每日体重', key: 'assessment_extras.checked1' },
  { label: '严格输入/输出', key: 'assessment_extras.checked2' },
  { label: '跌倒风险', key: 'assessment_extras.checked3' },
  { label: '观察', key: 'assessment_extras.checked4' },
  { label: '1:1陪护', key: 'assessment_extras.checked5' },
  { label: '午夜后禁食', key: 'assessment_extras.checked6' },
];

const checks_iv_RL = [
  { label: '右', key: 'assessment_iv_rs.checked1' },
  { label: '左', key: 'assessment_iv_rs.checked2' },
];

const checks_iv_site = [
  { label: '肘前', key: 'assessment_iv_site.checked1' }, // AC
  { label: '前臂', key: 'assessment_iv_site.checked2' }, // FA
  { label: '手', key: 'assessment_iv_site.checked3' },
  { label: '手腕', key: 'assessment_iv_site.checked4' },
  { label: '上臂', key: 'assessment_iv_site.checked5' }, // UA
  { label: '等等', key: 'assessment_iv_site.checked6' },
];

const checks_iv_central = [
  { label: '颈内静脉', key: 'assessment_iv_central.checked1' }, // IJ
  { label: '经外周插入中心静脉导管', key: 'assessment_iv_central.checked2' },
  { label: '端口', key: 'assessment_iv_central.checked3' },
  { label: '三腔导管', key: 'assessment_iv_central.checked4' }, // Trialysis
];

const Assessment1 = (props: Props) => {
  const { disabled, register, getValues, setValue } = props;

  return (
    <>
      <SectionTitle title="A (Assessment)" />
      <RowContainer
        xs={12}
        sx={{ margin: '20px auto 5px auto', marginLeft: '-25px' }}
      >
        <RowContent title="接触" titleRatio={1} childrenRatio={10.3}>
          <Stack direction="row" spacing={1}>
            {checks.map((v, i) => {
              return (
                <Grid item xs={2}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                      sx={{ width: '100%', whiteSpace: 'pre-wrap' }}
                    />
                  </Stack>
                </Grid>
              );
            })}
          </Stack>
        </RowContent>
        <RowContent title="需要" titleRatio={1} childrenRatio={10.3}>
          <Stack direction="row" spacing={1}>
            {checks2.map((v, i) => {
              return (
                <Grid item xs={1.4}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
          </Stack>
        </RowContent>
        <RowContent title="额外事项" titleRatio={1} childrenRatio={10.3}>
          <Stack direction="row" spacing={1}>
            {checks3.map((v, i) => {
              return (
                <Grid item xs={1.4}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
          </Stack>
        </RowContent>
        <RowContent title="静脉注射" titleRatio={1} childrenRatio={10.3}>
          <Stack direction="row" spacing={1}>
            <Grid item xs={2.7}>
              <Stack direction="row" spacing={3}>
                <Form.MuiTextField
                  required={false}
                  sx={{ width: '190px' }}
                  disabled={disabled}
                  InputProps={{ ...Form.adornment('#', '') }}
                  {...register(`assessment_iv_input`)}
                />
                <Form.MuiTextField
                  required={false}
                  sx={{ width: '190px' }}
                  disabled={disabled}
                  placeholder="进入"
                  type="date"
                  {...register(`assessment_iv_date`)}
                />
              </Stack>
            </Grid>
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={1} childrenRatio={10.3}>
          <Stack direction="row" spacing={1}>
            <Grid item xs={1.4}>
              <Typography
                variant="caption"
                fontWeight={400}
                lineHeight="38px"
                sx={{ whiteSpace: 'nowrap' }}
              >
                右/左
              </Typography>
            </Grid>
            {checks_iv_RL.map((v, i) => {
              return (
                <Grid item xs={i === 1 ? 1 : 1.4}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={1} childrenRatio={10.3}>
          <Stack direction="row" spacing={1}>
            <Grid item xs={1.4}>
              <Typography
                variant="caption"
                fontWeight={400}
                lineHeight="38px"
                sx={{ whiteSpace: 'nowrap' }}
              >
                部位
              </Typography>
            </Grid>
            {checks_iv_site.map((v, i) => {
              return (
                <Grid item xs={i === 5 ? 0.5 : 1.4}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
            <Form.MuiTextField
              required={false}
              sx={{ width: '90px' }}
              disabled={disabled}
              placeholder="进入"
              {...register(`assessment_iv_site_input`)}
            />
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={1} childrenRatio={10.3}>
          <Stack direction="row" spacing={1}>
            <Grid item xs={1.4}>
              <Typography
                variant="caption"
                fontWeight={400}
                lineHeight="38px"
                sx={{ whiteSpace: 'nowrap' }}
              >
                中央
              </Typography>
            </Grid>
            {checks_iv_central.map((v, i) => {
              return (
                <Grid item xs={i === 1 ? 2 : 1.4}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
          </Stack>
        </RowContent>
      </RowContainer>
    </>
  );
};

export default Assessment1;
